// extracted by mini-css-extract-plugin
export default {"root":"styles_root__6Flxl","dragging-over":"styles_dragging-over__bJDLy","draggingOver":"styles_dragging-over__bJDLy","color":"styles_color__9yZNc"};